
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Metagroup } from 'app/assetgroup/metagroup/metagroup';
import { MetagroupService } from 'app/core/metagroup.service';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class MetagroupsResolver {
  private metagroupService = inject(MetagroupService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  resolve(route: ActivatedRouteSnapshot): Observable<Metagroup[]> {
    const scope = route.paramMap.get('scope') || '';
    return this.metagroupService.getMetagroups(scope).pipe(
      publishReplay(1),
      refCount(),
    );
  }
}
